import React, { memo } from 'react';

import * as S from './header.styles'
import { LotQuery } from '../types'
import { StaticLotData } from '../schema.design';
import { BreadCrumbs } from './BreadCrumbs';
import { SpotifyNowPlayingStream } from '../SpotifyNowPlaying/SpotifyNowPlaying'

export const LotHeader: React.FC<{
  title: StaticLotData['title']
  categories: StaticLotData['categories']
  sale: StaticLotData['sale']
  watching: number
  isWatching: boolean
  setIsWatching: React.Dispatch<React.SetStateAction<boolean>>
  lotQuery: LotQuery
}> = memo(({ title, categories, sale, lotQuery }) => {
  return (
    <S.Header>
      <BreadCrumbs categories={categories} sale={sale} lotQuery={lotQuery} />
      <S.H1>{title}</S.H1>
      <SpotifyNowPlayingStream />
    </S.Header>
  )
})
export { LotHeaderLoading } from './header.styles';
